export function download(data, strFileName, strMimeType) {
  const anchor = document.createElement("a");
  const url = URL.createObjectURL(new Blob([data], { type: strMimeType }));
  anchor.href = url;
  anchor.download = strFileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}
